/**
 * 会社のアイコン（#151、docs/60 §2・★3。射場さん 2026-10-07〜08 の決定：自社情報のロゴ、無ければ頭文字）。会社の切替から使い始め、ほかの画面にも使う。
 *   ・会社は角丸の四角（40px で角丸 10px。人＝右上の頭文字は丸なので、形で見分ける）
 *   ・ロゴ：白地・1px の区切りの枠・中に object-fit: contain（内側 4px）。読めなければ（onError）頭文字に落とす
 *   ・頭文字：地 --ai3・藍・太字（40px のとき 18px＝var(--fs-18)）。initial は API が companyInitial で作った字（会社名が空なら null＝建物のアイコン）。
 *     initial を渡さない（undefined）ときはここで companyInitial(name)
 *   ・会社名はいつも隣に字で出すので、アイコンは読み上げない（aria-hidden）
 *   大きさは size（px）。40 以外は CSS の --co-k（size / 40）で角丸・字・建物のアイコンを同じ割合で変える（.coicon、styles.css の「会社の切替（#151）」）
 */
import { companyInitial } from "@genbaryoku/contract";
import { useState, type CSSProperties } from "react";

export function CompanyIcon({ name, logoUrl, initial, size = 40 }: { name: string; logoUrl?: string | null | undefined; initial?: string | null | undefined; size?: number }) {
  // 読めなかったロゴの URL（URL が変われば、もう一度ロゴを試す）
  const [broken, setBroken] = useState<string | null>(null);
  const style = size === 40 ? undefined : ({ "--co-k": size / 40 } as CSSProperties);
  if (logoUrl && broken !== logoUrl) {
    return (
      <span className="coicon is-logo" style={style} aria-hidden="true">
        <img src={logoUrl} alt="" decoding="async" onError={() => setBroken(logoUrl)} />
      </span>
    );
  }
  const ch = initial === undefined ? companyInitial(name) : initial;
  return (
    <span className="coicon" style={style} aria-hidden="true">
      {ch ?? (
        <svg viewBox="0 0 24 24">
          <path d="M4 21V5.5L12 3v18M12 21V9l8 2.5V21M2.5 21h19M7 8h2M7 12h2M7 16h2M15 13h2M15 17h2" />
        </svg>
      )}
    </span>
  );
}
